module.exports = __webpack_public_path__ + "static/img/ic_Android_ browser.1d0e951.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/ic_Android_ browser.png
// module id = 327
// module chunks = 32